import { z } from 'zod'

export const trainerXanoGrantExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoGrantExceptionResponse = z.infer<typeof trainerXanoGrantExceptionResponseSchema>
